import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { resendActivationEmail } from 'src/app/root-store/jobseeker-store/jobseeker-registration/actions';
import { selectEmailVerificationResendToken, selectResendMaxAttemptsReached } from 'src/app/root-store/jobseeker-store/jobseeker-registration/selectors';
import { selectSystemConfigs } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';
import { SystemConfig } from 'src/app/shared/models/system-config-model';

@Component({
    selector: 'app-jobseeker-registration-complete',
    templateUrl: './jobseeker-registration-complete.component.html',
    styleUrls: ['./jobseeker-registration-complete.component.scss'],
    standalone: false
})
export class JobseekerRegistrationCompleteComponent implements OnInit {

  public maxResendAttemptsReached$: Observable<boolean>;
  public emailResendToken$: Observable<string>;
  public systemConfigs$: Observable<SystemConfig>;

  constructor(private store: Store<AppState>) { }

  onResend(emailResednToken: string){
    this.store.dispatch(resendActivationEmail({ payload: { emailVerificationResendToken: emailResednToken }}));
  }

  ngOnInit(): void {
    this.maxResendAttemptsReached$ = this.store.pipe(select(selectResendMaxAttemptsReached));
    this.emailResendToken$ = this.store.pipe(select(selectEmailVerificationResendToken));
    this.systemConfigs$ = this.store.pipe(select(selectSystemConfigs));
  }
}
